module.exports = __webpack_public_path__ + "img/taskdel-btn.f6a72c1e.svg";